import { render, staticRenderFns } from "./ThemeSoundAdd.vue?vue&type=template&id=19f6ca8e&"
import script from "./ThemeSoundAdd.vue?vue&type=script&lang=js&"
export * from "./ThemeSoundAdd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports